<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-red-packet`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 2h32a2 2 0 011.995 1.85L42 4v40a2 2 0 01-1.85 1.995L40 46H8a2 2 0 01-1.995-1.85L6 44V4a2 2 0 011.85-1.995L8 2h32H8zm30.001 21.087a37.741 37.741 0 01-6.055 1.845 8 8 0 01-15.892 0A37.71 37.71 0 0110 23.087V42h28l.001-18.913zM24 20a4 4 0 100 8 4 4 0 000-8zM38 6H10v12.74a33.752 33.752 0 006.6 2.217 8.002 8.002 0 0114.8-.002A33.64 33.64 0 0038 18.74V6z"/></svg>
</template>
<script>

export default {
  name: 'IconRedPacket',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
